import { useCallback, useEffect, useMemo, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaFileExcel ,FaFilePdf, FaMoneyBillWave, FaPlus, FaSearch, FaUserFriends, FaUserTie } from 'react-icons/fa';
import { MdDelete, MdEdit, MdClose } from 'react-icons/md';
import { TbCancel  } from 'react-icons/tb';
import { TiCancel   } from 'react-icons/ti';
import styles from "./prestamos.module.css";
import { api } from '../../utils/services/api';
import { APP_OPTIONS, SERVICE } from '../../utils/constants/services';
import Swal from 'sweetalert2';
import WindowLayout from '../../utils/layout/windowsLayout';
import Select from 'react-select';
import ModalPrestamos from './prestamosModal';
import Amortizacion from './amortizacion';
import { FaTableList } from 'react-icons/fa6';
import { FaEllipsisV, FaEdit, FaTrash, FaEye } from 'react-icons/fa';
import { downloadPDFFromBase64, isMobileDevice, openPDFInNewWindow } from '../../utils/downloadUtils';



const customStyles = {
    headRow: {
        style: {
            minHeight: "40px",
            backgroundColor: "#046cc2",
            fontSize: "15px",
            color: "white",
        },
    },


};
export default function Prestamos(props) {
    const {userId, windowSize, clientActual, setClientActual, setMenuActual,permisos } = useAuth();
    const { clientId } = props
    const isReadOnlyMode = permisos.findIndex(item => item.identifier === "PrestReadMode") !== -1;

    const [showModal, setShowModal] = useState(false);
    const [showAmor, setShowAmor] = useState(false);
    const [showAmorT, setShowAmorT] = useState(false);
    const [dataTable, setDataTable] = useState([]);
    const [roles, setRoles] = useState([]);
    const [userEdit, setUserEdit] = useState(null);
    const [ofices, setOfices] = useState([]);
    const { estados, municipios, codigos } = useAuth();
    const [genders, setGenders] = useState([]);

    const [loadingTable, setLoadingTable] = useState(false);
    const [totalRows, setTotalRows] = useState(10);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(50);
    const [textSearch, setTextSearch] = useState("");

    const [textSearchPrev, setTextSearchPrev] = useState("");

    const [asesorSelect, setAsesorSelect] = useState(null);
    const [asesores, setAsesores] = useState([]);
    const [asesorLocked, setAsesorLocked] = useState(false);

    const [statusSelect, setStatusSelect] = useState(null);
    const [statusOptions, setStatusOptions] = useState([]);

    const [companieAll, setCompanieAll] = useState([]);
    const [companieSelect, setCompanieSelect] = useState(null);

    const [distribuidores, setDistribuidores] = useState([]);
    const [distribuidorSelect, setDistribuidorSelect] = useState(null);
    const [clientsAll, setClientsAll] = useState([]);
    const [clientsSelect, setClientsSelect] = useState(null);
    const [clients, setClients] = useState([]);
    const [prestamoActual, setPrestamoActual] = useState(null);
    const [estatusAll, setEstatusAll] = useState([{
        value: 1,
        label: "Asignado"
    },
    {
        value: 2,
        label: "Por asignar"
    }]);
    const [estatusSelect, setEstatusSelect] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const [toggleCleared, setToggleCleared] = useState(false);
    const [loadingPrint2, setLoadingPrint2] = useState(false);
    const [convenioData, setConvenioData] = useState(null);
    const [isConvenioMode, setIsConvenioMode] = useState(false);





    const columns = [
        
        {
            name: 'Acciones',
            cell: (row) => 
                 (
                    <div style={{ display: "flex", gap: "5px",justifyContent:"left",width:"100%" }}>
                        <button 
                            className='btn btn-sm btn-primary' 
                            onClick={() => {
                                setPrestamoActual(row);
                                setShowAmor(true);
                            }}
                            title="Ver Tabla de Amortización"
                        >
                            <FaTableList />
                        </button>
                       
                        {!isReadOnlyMode && (
                            <>
                                <button 
                                    className={row.typeClient === "CLT" ? 'btn btn-sm btn-warning' : 'btn btn-sm btn-secondary'}
                                    onClick={() => handleCreateConvenio(row)}
                                    title="Crear Convenio"
                                    disabled={row.typeClient !== "CLT"}
                                >
                                    <FaPlus />
                                </button>
                                <button 
                                    className={`btn ${styles.btnCancel}`} 
                                    onClick={() => handleCancel(row.id)}
                                    title="Cancelar Prestamo"
                                    disabled={row.lastStatus === "CANCELADO"}
                                >
                                    <TbCancel  color={row.lastStatus === "CANCELADO" ? "white" : "red"} />
                                </button>
                                <button 
                                    className='btn btn-sm btn-danger' 
                                    onClick={() => handleDelete(row.number || 'N/A', row.id)}
                                    title="Eliminar Prestamo"
                                    disabled={!row.id}
                                >
                                    <MdDelete />
                                </button>
                            </>
                        )}
                    </div>
                )
            ,
            width: '170px',
            center: true,
        },
        {
            name: 'Cliente',
            cell: row => (
                <div style={{
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    lineHeight: '1.4',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}>
                    {row.typeClient === "EMP" && (
                        <FaUserTie 
                            style={{ 
                                color: '#6f42c1', 
                                fontSize: '16px',
                                flexShrink: 0
                            }} 
                            title="Empleado"
                        />
                    )}
                    <span style={{ wordBreak: 'break-word' }}>
                        {row.clientName || 'Sin nombre'}
                    </span>
                </div>
            ),
            wrap: true,
            sortable: true,
            minWidth: '200px',
        },
        {
            name: 'Asesor',
            selector: row => row.advisorName || 'N/A',
            sortable: true,
            width: '200px',
            wrap: true,
        },
        {
            name: 'Folio',
            selector: row => formatFolio(row.id),
            sortable: true,
            width: '100px',
        },
        {
            name: 'Tipo',
            selector: row => row.paymentFrequency || 'N/A',
            sortable: true,
            width: '100px',
        },
        {
            name: 'Pago',
            selector: row => `$ ${(row.amountPaymentFrequency || 0).toLocaleString('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}`,
            sortable: true,
            width: '120px',
        },
        {
            name: 'Monto',
            selector: row => `$ ${(row.amount || 0).toLocaleString('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}`,
            sortable: true,
            width: '120px',
        },
        {
            name: 'Intereses',
            selector: row => `$ ${(row.amountInterest || 0).toLocaleString('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}`,
            sortable: true,
            width: '120px',
            omit: windowSize?.width <= 768,
        },
        {
            name: 'Total a Pagar',
            selector: row => `$ ${(row.amountPayable || 0).toLocaleString('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}`,
            sortable: true,
            width: '150px',
        },
        {
            name: 'Monto Pagado',
            selector: row => `$ ${(row.amountPayment || 0).toLocaleString('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}`,
            sortable: true,
            width: '160px',
        },
         {
            name: 'Atrasados',
            selector: row => row.pendingPayments || 0,
            sortable: true,
            width: '130px',
        }, 
        {
            name: 'Deuda',
            selector: row => `$ ${(row.debt || 0).toLocaleString('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}`,
            sortable: true,
            width: '150px',
        },
        {
            name: 'F. Inicio',
            selector: row => row.startDate ? row.startDate.split("T")[0] : 'N/A',
            sortable: true,
            width: '110px',
            omit: windowSize?.width <= 576,
        },
        {
            name: 'F. Fin',
            selector: row => row.endDate ? row.endDate.split("T")[0] : 'N/A',
            sortable: true,
            width: '110px',
            omit: windowSize?.width <= 576,
        },
        {
            name: 'Status',
            cell: row => {
                const status = row.lastStatus || 'UNKNOWN';
                return (
                    status === "MORATORIO" ? (
                          <span className="badge bg-warning">{status}</span>
                    )
                    :
                    status === "ACTIVO" ? (
                          <span className="badge bg-success">{status}</span>
                    ) 
                     :
                    status === "VENCIDO" ? (
                          <span className="badge bg-danger">{status}</span>
                    ) 
                     :
                    status === "PAGADO" ? (
                          <span className="badge bg-primary">{status}</span>
                    ) 
                    :
                    (
                        <span className="badge bg-secondary">{status}</span>
                    )  
                );
            },
            wrap: true,
            sortable: true,
            minWidth: '100px',
            omit: windowSize?.width <= 768,
        },
       
    ];
    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);
    const formatFolio = (number, totalDigits = 6) => {
        const numberStr = number.toString();
        const zerosNeeded = Math.max(0, totalDigits - numberStr.length);
        const zeros = '0'.repeat(zerosNeeded);
        return `F-${zeros}${numberStr}`;
    };

    const handleClearRows = useCallback(() => {
        setToggleCleared(!toggleCleared);
        setSelectedRows([]);
    }, [toggleCleared]);

    const handleCreateConvenio = (rowData) => {
        if (isReadOnlyMode) return;
        setConvenioData(rowData);
        setIsConvenioMode(true);
        setShowModal(true);
    };
    const handleDownloadReportInconsistencias = () => {
            api(SERVICE.getReportPrestamos)
                .then((data) => {
                    if (data.data.data) {
                        const info = data.data.data;
                        const fileName = "Reporte_Prestamos.xlsx";
                        
                        const success = downloadPDFFromBase64(info, fileName);
                        
                        if (!success && isMobileDevice()) {
                            openPDFInNewWindow(info);
                        }
                    } 
                })
                .catch((err) => {
                    console.log(err);
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: "Error al descargar el reporte",
                        text: "Inténtalo de nuevo",
                        showConfirmButton: true
                    });
                })
                .finally(() => {
                  
                })
        
    }
    const handleDelete = (userName, userId) => {
        const tienePermisoEliminar = permisos.findIndex(item => item.identifier === "DeleteLoans") !== -1;
        if(tienePermisoEliminar){
            Swal.fire({
            title: "¿Está segur@ que desea eliminar el préstamo?",
            showCancelButton: true,
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6"
        }).then((result) => {
            if (result.isConfirmed) {
                api(SERVICE.deletePrestamo + `?LoanId=${userId}`, {}, "DELETE")
                    .then((data) => {
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "Préstamo eliminado correctamente",
                            showConfirmButton: false,
                            timer: 1500
                        });
                        handleUpdate();
                    })
                    .catch((err) => {
                        console.log(err);
                        Swal.fire({
                            position: "center",
                            icon: "error",
                            title: "Error al eliminar el préstamo",
                            text: "Por favor intente de nuevo",
                            showConfirmButton: true
                        });
                    })
            }
        });
        }else{
                 Swal.fire({
                            position: "center",
                            icon: "info",
                            title: "Sin permisos",
                            text: "No tiene permisos para eliminar prestamos",
                            showConfirmButton: true
                        });
        }
        
    }

     const handleCancel = (id) => {
          if (isReadOnlyMode) return;
        Swal.fire({
            title: "¿Esta segur@ que desea cancelar el prestamo ?",
            showCancelButton: true,
            confirmButtonText: "Eliminar",
            denyButtonText: "Cancelar"
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                let URL = SERVICE.cancelPrestamo;
                 let METHOD = "POST";
                 let payload = {
                "LoanId": id,
                "UserId": userId,
                "StatusIdentifier": "CAN",
                "Comments":"Prestamo Cancelado (Usuario)"
                }
                 api(URL, payload, METHOD)
                                .then((data) => {
                                    Swal.fire({
                                        position: "center",
                                        icon: "success",
                                        title: "Prestamo Cancelado Correctamente",
                                        showConfirmButton: false,
                                        timer: 1500
                                    });
                                    handleUpdate();
                                  
                                })
                                .catch((err) => {
                                    console.log(err);
                                })
            }
        });

    }
    const handleGetClients = () => {
        api(SERVICE.getPersonalAll)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            ...element,
                            value: element.id,
                            label: `${element.fathersLastName || ''} ${element.mothersLastName || ''} ${element.names || ''}`.trim() || 'Sin nombre'
                        });

                    }
                }
                setClientsAll(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleGetOffice = () => {
        api(SERVICE.getOfices)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.description || 'Sin descripción',
                            stateId: element.stateId,
                            municipalityId: element.municipalityId
                        });

                    }
                }
                setOfices(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    
    const handleGetAsesortes = () => {
        api(SERVICE.getAsesoresAll)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.completeName
                        });
                    }
                }
                setAsesores(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }

    const handleGetLoansStatus = () => {
        api(SERVICE.getLoansStatus)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.identifier,
                            label: element.description
                        });
                    }
                }
                setStatusOptions(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }

    const handleGetClientsByAdvisor = (asesorId) => {
        let URL = SERVICE.getClientsAdvisor;
        if(asesorId){
            URL += `?AdvisorId=${asesorId}`;
        }
        api(URL)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.clientName,
                            typeClient: 'CLT'
                        });
                    }
                }
                setClients(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
                setClients([]);
            })
    }

    const handleSearch = () => {
        setLoadingTable(true);
        let URL = SERVICE.getPrestamos + `?TypeSearch=1&Page=${page}&PageSize=${perPage}`;
        if (textSearch !== "") {
            URL = URL + `&TextSearch=${textSearch}`;
        }
        if (asesorSelect && asesorSelect.value && clientActual == null) {
            URL = URL + `&AdvisorId=${asesorSelect.value}`;
        }
        if (statusSelect && statusSelect.value) {
            URL = URL + `&Status=${statusSelect.value}`;
        }
        if (clientActual !== null) {
            URL = URL + `&ClientId=${clientActual.Id}`;
        }
        else {
            if (clientsSelect != null) {
                URL = URL + `&ClientId=${clientsSelect.value}`;
            }
        }
        setTextSearchPrev(textSearch);
        setTextSearch("");
        api(URL)
            .then((data) => {
                let arrayTemp = [];
                if(data && data.data && data.data.paginationInfo){
                    setTotalRows(data.data.paginationInfo.totalRecords);
                }
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push(element);
                    }
                }
                setDataTable(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setLoadingTable(false);
            })
    };

    const handleUpdate = useCallback(() => {
        setLoadingTable(true);
        let URL = SERVICE.getPrestamos + `?TypeSearch=1&Page=${page}&PageSize=${perPage}`;
        if (asesorSelect && asesorSelect.value && clientActual == null) {
            URL = URL + `&AdvisorId=${asesorSelect.value}`;
        }
        if (statusSelect && statusSelect.value) {
            URL = URL + `&Status=${statusSelect.value}`;
        }
        if (clientActual !== null) {
            URL = URL + `&ClientId=${clientActual.Id}`;
        }
        else {
            if (clientsSelect != null) {
                URL = URL + `&ClientId=${clientsSelect.value}`;
            }
        }
        api(URL)
            .then((data) => {
                let arrayTemp = [];
                if(data && data.data && data.data.paginationInfo){
                    setTotalRows(data.data.paginationInfo.totalRecords);
                }
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push(element);
                    }
                }
                setDataTable(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setLoadingTable(false);
            })
    }, [page, perPage, asesorSelect, statusSelect, clientActual, clientsSelect]);
    const handleUpdateNosearch = () => {
        setLoadingTable(true);
        let URL = SERVICE.getPrestamos + `?TypeSearch=1&Page=${page}&PageSize=${perPage}`;
        if (asesorSelect && asesorSelect.value && clientActual == null) {
            URL = URL + `&AdvisorId=${asesorSelect.value}`;
        }
        if (statusSelect && statusSelect.value) {
            URL = URL + `&Status=${statusSelect.value}`;
        }
        if (clientActual !== null) {
            URL = URL + `&ClientId=${clientActual.Id}`;
        }
        api(URL)
            .then((data) => {
                let arrayTemp = [];
                if(data && data.data && data.data.paginationInfo){
                    setTotalRows(data.data.paginationInfo.totalRecords);
                }
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push(element);
                    }
                }
                setDataTable(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setLoadingTable(false);
            })
    }
    // const handleUpdateRoles = () => {

    //     api(SERVICE.getRoles)
    //         .then((data) => {
    //             let arrayTemp = [];
    //             for (let index = 0; index < data.data.data.length; index++) {
    //                 const element = data.data.data[index];
    //                 arrayTemp.push({
    //                     id: element.id,
    //                     identifier: element.identifier,
    //                     description: element.description
    //                 })
    //             }
    //             setRoles(arrayTemp);
    //         })
    //         .catch((err) => {

    //         })
    // }
    const handleGetGenders = () => {
        api(SERVICE.getGenders)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.description
                        });

                    }
                }
                setGenders(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleGetDistribuidores = () => {
        let URL = "/Distributors" + SERVICE.getPersonal;

        api(URL)
            .then((data) => {
                let arrayTemp = [];

                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];

                        arrayTemp.push({
                            value: element.distributorId,
                            label: element.distributorName
                        });

                    }
                }
                setDistribuidores(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleGetCompanies = async () => {
        let URL = SERVICE.getCompaniegrid;
        let arrayTemp2 = [];
        await api(URL)
            .then(async (data) => {

                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        await api(SERVICE.getCompanieSuc + element.id)
                            .then((data) => {
                                if (data.data.data) {
                                    for (let index = 0; index < data.data.data.length; index++) {
                                        const sucursalCom = data.data.data[index];

                                        arrayTemp2.push({
                                            label: element.companyName + " - " + sucursalCom.centralOfficeName + " - " + sucursalCom.descriptionAddress,
                                            value: sucursalCom.id
                                        });
                                        console.log("arrayTemp2p", arrayTemp2);
                                    }
                                }
                            })
                            .catch((err) => {
                                console.log(err);
                            })

                    }

                }

            })
            .catch((err) => {
                console.log(err);
            })
        setCompanieAll(arrayTemp2);
    }
    const handleAction = async (action) => {
        setLoadingPrint2(true);
        if (selectedRows.length === 0) {
            selectedRows.push({ 
                id:0,
                clientName:"Formato_Vacio"
            })
        }

        for (let index = 0; index < selectedRows.length; index++) {
            const element = selectedRows[index];
            await api(SERVICE.getReportLoan + `${action}/By/${element.id}`)
                .then((data) => {
                    if (data.data.data) {
                        const info = data.data.data;
                        const fileName = "Reporte_" + action + "_" + element.clientName + ".pdf";
                        
                        const success = downloadPDFFromBase64(info, fileName);
                        
                        if (!success && isMobileDevice()) {
                            openPDFInNewWindow(info);
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: "Error al descargar el reporte",
                        text: "Inténtalo de nuevo",
                        showConfirmButton: true
                    });
                })
                .finally(() => {

                })
        }


        setLoadingPrint2(false);

    };
    useEffect(() => {
        //handleGetCompanies();
        //handleGetDistribuidores();
        handleGetOffice();
        handleGetClients();
        handleGetAsesortes();
        handleGetLoansStatus();
    }, [])
    
    useEffect(() => {
        handleGetClientsByAdvisor(asesorSelect ? asesorSelect.value : null);
    }, [asesorSelect])
    
    useEffect(() => {
        // Si hay un clientActual, buscar y seleccionar su asesor, luego bloquear el campo
        if (clientActual && clientActual.Id && asesores.length > 0) {
            // Primero, buscar el cliente en clientsAll para obtener su advisorId
            const clienteEncontrado = clientsAll.find(c => c.id === clientActual.Id);
            if (clienteEncontrado && clienteEncontrado.advisorId) {
                const asesorEncontrado = asesores.find(a => a.value === clienteEncontrado.advisorId);
                if (asesorEncontrado) {
                    setAsesorSelect(asesorEncontrado);
                    setAsesorLocked(true);
                    // Cargar clientes del asesor y seleccionar el cliente actual
                    handleGetClientsByAdvisor(clienteEncontrado.advisorId);
                    setTimeout(() => {
                        const clienteSeleccionado = {
                            value: clientActual.Id,
                            label: clientActual.Name,
                            typeClient: clientActual.typeClient
                        };
                        setClientsSelect(clienteSeleccionado);
                    }, 500);
                }
            }
        } else {
            setAsesorLocked(false);
        }
    }, [clientActual, asesores, clientsAll])
    
    useEffect(() => {
        handleUpdate();
    }, [page, perPage, asesorSelect, clientsSelect, statusSelect, handleUpdate])
    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handlePerRowsChange = (newPerPage) => {
        setPerPage(newPerPage);
    };
    const contextActions = useMemo(() => {
        if (isReadOnlyMode) {
            return null;
        }

        const handleDeleteSelected = async () => {
            if (selectedRows.length === 0) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Sin selección',
                    text: 'Por favor seleccione al menos un préstamo para eliminar'
                });
                return;
            }

            const result = await Swal.fire({
                title: `¿Está seguro de eliminar ${selectedRows.length} préstamo${selectedRows.length > 1 ? 's' : ''}?`,
                text: `Se eliminarán: ${selectedRows.map(r => `Folio ${formatFolio(r.id)}`).join(', ')}`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6"
            });

            if (result.isConfirmed) {
                let eliminados = 0;
                let errores = 0;

                for (const row of selectedRows) {
                    try {
                        await api(SERVICE.deletePrestamo + `?LoanId=${row.id}`, {}, "DELETE");
                        eliminados++;
                    } catch (error) {
                        console.log(error);
                        errores++;
                    }
                }

                if (eliminados > 0) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Préstamos eliminados',
                        text: `Se eliminaron ${eliminados} préstamo${eliminados > 1 ? 's' : ''}${errores > 0 ? ` (${errores} error${errores > 1 ? 'es' : ''})` : ''}`,
                        timer: 2000
                    });
                    handleUpdate();
                    handleClearRows();
                } else if (errores > 0) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al eliminar',
                        text: 'No se pudieron eliminar los préstamos seleccionados'
                    });
                }
            }
        };

        return (
            <div className={styles.contextActions}>
                <button key="delete" onClick={handleDeleteSelected} className="btn btn-danger btn-sm">
                    <MdDelete /> Eliminar seleccionados
                </button>
                <button key="clear" onClick={handleClearRows} className="btn btn-secondary btn-sm ms-2">
                    <MdClose /> Limpiar selección
                </button>
            </div>
        );
    }, [selectedRows, handleClearRows, handleUpdate, isReadOnlyMode]);
    useEffect(() => {
        console.log("selectedRows", selectedRows)
    }, [selectedRows])
    
    // Estilos condicionales para diferenciar empleados
    const conditionalRowStyles = [
        {
            when: row => row.typeClient === "EMP",
            style: {
                backgroundColor: '#f8f9ff',
                borderLeft: '4px solid #6f42c1',
                '&:hover': {
                    backgroundColor: '#e7e8ff',
                    cursor: 'pointer',
                },
            },
        },
        {
            when: row => row.typeClient === "CLT",
            style: {
                borderLeft: '4px solid #ffffffff',
            },
        },
    ];
    
    return (
        <>
            <WindowLayout
                title="Prestamos"
                route={clientActual !== null ? ["Prestamos", "Clientes", "Prestamos " + clientActual.Name] : ["Prestamos", "Prestamos"]}
                actions={clientActual !== null ? [() => {
                    setClientActual(null);
                    setMenuActual("prestamoMenu");
                }, () => {
                    setClientActual(null);
                    setMenuActual("prestamo1");
                }] : [() => {
                    setClientActual(null);
                    setMenuActual("prestamoMenu");
                }]}
                icon={<FaUserFriends />}
            >
                <div className='paperContainer'>
                    {/* Filtros */}
                    <div style={{ display: "flex", justifyContent: "left", alignItems: "center", flexWrap: "wrap", margin: "10px 0" }}>
                        <div className={styles.itemForm} style={{ zIndex: 7, display: clientActual !== null ? "none" : "" }}>
                            <label className="form-label">Asesor: </label>
                            <Select 
                                isDisabled={asesorLocked} 
                                isClearable 
                                options={asesores} 
                                className="" 
                                placeholder="Seleccionar Asesor" 
                                value={asesorSelect} 
                                onChange={(e) => setAsesorSelect(e)} 
                                styles={{
                                    container: (provided) => ({
                                        ...provided,
                                        minWidth: '250px'
                                    })
                                }}
                            />
                        </div>
                        <div className={styles.itemForm} style={{ zIndex: 6, display: clientActual !== null ? "none" : "" }}>
                            <label className="form-label">Cliente: </label>
                            <Select 
                                isClearable 
                                options={clients} 
                                className="" 
                                placeholder="Seleccionar Cliente" 
                                value={clientsSelect} 
                                onChange={(e) => setClientsSelect(e)} 
                                styles={{
                                    container: (provided) => ({
                                        ...provided,
                                        minWidth: '250px'
                                    })
                                }}
                            />
                        </div>
                        <div className={styles.itemForm} style={{ zIndex: 5 }}>
                            <label className="form-label">Status: </label>
                            <Select 
                                isClearable 
                                options={statusOptions} 
                                className="" 
                                placeholder="Seleccionar Status" 
                                value={statusSelect} 
                                onChange={(e) => setStatusSelect(e)} 
                                styles={{
                                    container: (provided) => ({
                                        ...provided,
                                        minWidth: '250px'
                                    })
                                }}
                            />
                        </div>
                    </div>
                    
                    
                    
                    <div className={styles.containerSearch}>
                        <div className={styles.searchWrapper}>
                            <div className="input-group">
                                <input type="text" className="form-control" placeholder="# Folio" value={textSearch} onChange={(e) => setTextSearch(e.target.value)} aria-describedby="addon-wrapping" />
                                <button className='btn btn-primary' onClick={handleSearch}><FaSearch /></button>
                            </div>
                        </div>
                       <div className={styles.buttonActions}>
                            {!isReadOnlyMode && (
                                <button className='btn btn-success' onClick={() => setShowModal(!showModal)}>
                                    <FaPlus /> Nuevo
                                </button>
                            )}
                             <button onClick={handleDownloadReportInconsistencias} className='btn btn-info'><FaFileExcel></FaFileExcel>&nbsp; Prestamos</button>
                            <div className="dropdown">
                                <button
                                    className="btn btn-info dropdown-toggle"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    style={{ color: "white", backgroundColor: "#0066cc", borderColor: "#0066cc" }}
                                >
                                    <FaFilePdf /> Reportes
                                </button>
                                <ul className="dropdown-menu" style={{ zIndex: "99999" }}>
                                    <li>
                                        <button
                                            className="dropdown-item"
                                            onClick={() => handleAction('LR')}
                                        >
                                            <FaFilePdf className="me-2" /> Solicitud del crédito
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            className="dropdown-item"
                                            onClick={() => handleAction('PN')}
                                        >
                                            <FaFilePdf className="me-2" /> Pagaré
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            className="dropdown-item"
                                            onClick={() => handleAction('CC')}
                                        >
                                            <FaFilePdf className="me-2" /> Tarjeta de cobro
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            {loadingPrint2 && (
                                <button className="btn btn-primary" type="button" disabled>
                                    <div className="spinner-border spinner-border-sm text-light" role="status">
                                        <span className="visually-hidden">Cargando...</span>
                                    </div>
                                </button>
                            )}
                        </div>
                    </div>
                    <div class="input-group flex-nowrap" style={{ marginBottom: "10px", width: "500px", display: "none" }}>
                        <input type="text" class="form-control" placeholder="Busqueda" value={textSearch} onChange={(e) => setTextSearch(e.target.value)} aria-describedby="addon-wrapping" />
                        <button className='btn btn-primary' onClick={handleSearch}><FaSearch /></button>
                    </div>
                    <div class="input-group flex-nowrap containerSearchPrev" style={{ display: textSearchPrev !== "" ? "flex" : "none" }}>
                        <div class="badgeSearch">Buscando por: <b>{textSearchPrev}</b> </div><div onClick={() => {
                            setTextSearch("");
                            setTextSearchPrev("");
                            handleUpdateNosearch();
                        }} className='divCloseSearch'><MdClose></MdClose></div>
                    </div>
                    <div className="table-responsive">
                        <DataTable
                            columns={columns}
                            data={dataTable}
                            customStyles={windowSize?.width <= 768 ? APP_OPTIONS.TABLE_SETTING_SM : APP_OPTIONS.TABLE_SETTING}
                            conditionalRowStyles={conditionalRowStyles}
                            pagination
                            paginationServer
                            paginationTotalRows={totalRows}
                            paginationPerPage={perPage}
                            paginationRowsPerPageOptions={[50,70,100,150,200]}
                            onChangePage={handlePageChange}
                            onChangeRowsPerPage={handlePerRowsChange}
                            progressPending={loadingTable}
                            persistTableHead
                            fixedHeader
                            fixedHeaderScrollHeight="400px"
                            responsive
                            selectableRows={!isReadOnlyMode}
                            selectableRowsHighlight={!isReadOnlyMode}
                            onSelectedRowsChange={handleRowSelected}
                            contextActions={contextActions}
                            clearSelectedRows={toggleCleared}
                            noDataComponent="No se encontraron registros"
                        />
                    </div>

                </div>
            </WindowLayout>
            <ModalPrestamos
                show={showModal}
                setShow={setShowModal}
                ofices={ofices}
                dataEdit={userEdit}
                setDataEdit={setUserEdit}
                estados={estados}
                municipios={municipios}
                codigos={codigos}
                handleUpdate={handleUpdate}
                genders={genders}
                companieAll={companieAll}
                distribuidores={distribuidores}
                estatusAll={estatusAll}
                companieSelectM={companieSelect}
                distribuidorSelectM={distribuidorSelect}
                estatusSelectM={estatusSelect}
                clientsAll={clientsAll}
                clientsSelect={clientsSelect}
                convenioData={convenioData}
                isConvenioMode={isConvenioMode}
                setIsConvenioMode={setIsConvenioMode}
                setConvenioData={setConvenioData}
                isReadOnlyMode={isReadOnlyMode}
            />
            <Amortizacion
                show={showAmor}
                setShow={setShowAmor}
                showT={showAmorT}
                setShowT={setShowAmorT}
                prestamoActual={prestamoActual}
                setPrestamoActual={setPrestamoActual}
                handleUpdate={handleUpdate}
                isReadOnlyMode={isReadOnlyMode}
            />
        </>
    );
} 